export default {
  "overviewTitle": "充值数据概览",
  "coreMetrics": "核心指标",
  "monthOverMonth": "环比",
  "noPreviousMonth": "暂无上月数据",
  "revenueTrend": "近 6 个月充值收入趋势",
  "trendNote": "单位：万元 · 峰值 {peak}",
  "topCompanies": "Top 10 充值企业",
  "rank": "排名",
  "company": "企业 / 组织",
  "rechargeCount": "充值次数",
  "rechargeTotal": "充值总额",
  "emptyRecords": "暂无充值记录",
  "monthOrderCount": "本月共 {count} 笔充值订单",
  "resourceShare": "资源充值占比",
  "resourceShareCenter": "资源\n占比",
  "packageDistribution": "充值套餐售卖分布",
  "packageSalesCenter": "套餐\n售卖",
  "none": "暂无",
  "tenThousand": "万",
  "orderUnit": "笔",
  "companyUnit": "家",
  "monthOrders": "本月充值订单",
  "monthRevenue": "本月充值收入",
  "monthCompanies": "本月充值企业",
  "totalRevenue": "累计充值收入",
  "storageRecharges": "云存储充值",
  "smsRecharges": "短信充值",
  "aiRecharges": "AI 修图充值",
  "averageOrder": "平均客单价",
  "messages": "条",
  "images": "张",
  "cards": "张名片",
  "ai": "AI 修图",
  "storage": "云存储空间",
  "sms": "短信通知",
  "card": "名片数量",
  "manageTitle": "充值套餐管理",
  "createResource": "新增资源类型",
  "guide": "充值套餐面向企业使用者，用于在会员套餐额度之外单独补充 AI 修图、云存储空间、短信通知与名片数量等动态资源。每个资源类型包含多个套餐，额度用完可随时补购。",
  "aiCategory": "AI智能",
  "resourceCategory": "资源充值",
  "summaryDefault": "为企业提供灵活的资源补充服务",
  "descriptionDefault": "暂未填写资源套餐描述。",
  "packageTiers": "套餐档位",
  "tierCount": "{count} 档",
  "minPrice": "最低价",
  "maxPrice": "最高价",
  "editResource": "编辑资源",
  "configurePackages": "套餐配置",
  "delete": "删除",
  "emptyResources": "暂未配置充值资源类型",
  "resourceName": "资源名称",
  "resourceNamePlaceholder": "如 云存储空间",
  "displayIcon": "展示图标",
  "category": "分类主题",
  "unit": "计量单位",
  "unitPlaceholder": "如 GB / 条 / 张",
  "coverUrl": "封面图 URL（可选）",
  "optional": "可暂不设置",
  "coverUpload": "封面图上传（可选）",
  "clickUpload": "点击上传封面",
  "coverHint": "支持 JPG、PNG、WEBP、GIF，最大 10MB；保存时将上传并登记资源封面。",
  "summary": "一句话简介",
  "description": "套餐描述",
  "initialPackage": "首档套餐",
  "packageName": "套餐名称",
  "packageNamePlaceholder": "如 50 GB 基础包",
  "quantity": "充值数量",
  "price": "价格（元）",
  "tag": "标签",
  "tagPlaceholder": "如 热销",
  "cancel": "取消",
  "saveChanges": "保存修改",
  "confirmCreate": "确认新增",
  "packageDialogTitle": "套餐配置 · {name}",
  "packageTip": "为该资源类型维护多个套餐；充值数量填 -1 表示不限量。套餐有效期固定为 1 年，至少保留一个套餐配置。",
  "addTier": "＋ 添加套餐档位",
  "saveConfiguration": "保存配置",
  "iconStorage": "云存储",
  "iconImages": "图片素材",
  "iconCards": "名片/卡券",
  "iconAi": "AI 服务",
  "iconGeneric": "通用资源",
  "iconFiles": "文件资源",
  "iconDocuments": "资料文件",
  "iconDocumentService": "文档服务",
  "iconCollection": "资源集合",
  "iconCamera": "相机图片",
  "iconVideo": "视频服务",
  "iconLive": "直播视频",
  "iconAudio": "音频服务",
  "iconNotifications": "消息通知",
  "iconSmart": "智能处理",
  "iconAnalytics": "数据分析",
  "iconNetwork": "网络连接",
  "iconDevices": "设备终端",
  "iconPresentation": "演示服务",
  "iconPurchase": "购买服务",
  "iconWallet": "账户充值",
  "iconTime": "时长服务",
  "iconAcceleration": "加速服务",
  "iconFeatured": "特色服务",
  "iconBox": "资源包",
  "requiredName": "请输入资源名称",
  "requiredUnit": "请输入计量单位",
  "requiredInitialName": "请输入首档套餐名称",
  "validImage": "请选择有效图片",
  "coverTooLarge": "封面图不能超过 10MB",
  "missingObjectKey": "上传失败：未返回 object_key",
  "saveSuccess": "保存成功",
  "saveFailed": "保存失败",
  "atLeastOnePackage": "请至少保留一个填写完整的套餐",
  "packagesSaved": "套餐配置已保存",
  "deleteConfirm": "确认删除资源类型“{name}”吗？",
  "deleteTitle": "删除资源类型",
  "deleted": "已删除",
  "unlimited": "不限量",
  "rechargeTimes": "{count}次"
}
